module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "center full"
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "flexContainer fd-c full",
    attrs: {
      "id": "campaign"
    }
  }, [_c('h1', {
    staticClass: "ff-medium txtCenter createCampaign"
  }, [_vm._v(_vm._s(_vm.$t("campaign.create")))]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "campaignWrapper"
    }
  }, [_c('div', {
    staticClass: "center flexContainer jc-c"
  }, [_c('div', {
    staticClass: "form_campaing"
  }, [_c('div', {}, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label label"
  }, [_vm._v(_vm._s(_vm.$t("brand.name")))]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "campaign ff-medium size2of3",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('campaign.campaignName'),
      "maxlength": _vm.MAX_LENGTH_NAME,
      "minlength": "5"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shortName),
      expression: "shortName"
    }],
    staticClass: "campaign ff-medium size1of3 shortName",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "text",
      "maxlength": "5",
      "placeholder": _vm.$t('campaign.shortName')
    },
    domProps: {
      "value": (_vm.shortName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shortName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label label"
  }, [_vm._v(_vm._s(_vm.$t("campaign.startCampaign")))]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastCampaign),
      expression: "lastCampaign"
    }],
    staticClass: "campaign uppercase",
    class: {
      disabled: _vm.radioButton === 'campaignDate'
    },
    attrs: {
      "id": "soflow-color",
      "disabled": _vm.radioButton === 'campaignDate'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.lastCampaign = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    staticClass: "uppercase",
    attrs: {
      "selected": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$trad.campaignCreate.previousCampaign))]), _vm._v(" "), _vm._l((_vm.campaigns), function(campaign) {
    return _c('option', {
      key: campaign.id,
      staticClass: "uppercase",
      domProps: {
        "value": campaign
      }
    }, [_vm._v("\n                                        " + _vm._s(campaign.name) + "\n                                    ")])
  })], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startDate),
      expression: "startDate"
    }],
    staticClass: "campaign startDate",
    class: {
      disabled: _vm.radioButton === 'lastCampaign'
    },
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "date",
      "placeholder": "YYYY-MM-DD",
      "disabled": _vm.radioButton === 'lastCampaign'
    },
    domProps: {
      "value": (_vm.startDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startDate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label label"
  }, [_vm._v(_vm._s(_vm.$t("campaign.endCampaign")))]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endDate),
      expression: "endDate"
    }],
    staticClass: "campaign",
    attrs: {
      "type": "date",
      "placeholder": "YYYY-MM-DD"
    },
    domProps: {
      "value": (_vm.endDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endDate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('footer', {
    staticClass: "txtCenter"
  }, [_c('RoundedButton', {
    attrs: {
      "disabled": !_vm.canSave
    },
    on: {
      "click": function($event) {
        _vm.createCampaign();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("campaign.createBtn")) + " ")])], 1)])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d843395","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign/Campaign.vue
// module id = 3012
// module chunks = 0